// @ts-nocheck
/* ═══════════════════════════════════════════════════════════════════
   PRODUCT INFO CUSTOM  ·  product-info-custom.js  v2.0
   Markets-aware pricing + native Shopify Selling Plans
   ─────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  const $  = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  function piHeaderOffset() {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-offset').trim();
    const n = parseInt(raw, 10);
    return Number.isNaN(n) ? 80 : n;
  }

  function piStickyBarIsRenderable(bar) {
    if (!bar || bar.hasAttribute('hidden')) return false;
    const style = getComputedStyle(bar);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function piStickyBarHeight(sectionEl) {
    const bar = $('[data-pi-sticky-bundle]', sectionEl);
    if (!piStickyBarIsRenderable(bar) || !bar.classList.contains('is-visible')) return 0;
    return bar.offsetHeight > 0 ? bar.offsetHeight : 72;
  }

  function piResolveScrollTarget(sectionEl, id) {
    if (!id) return null;
    let target = document.getElementById(id);
    if (!target && sectionEl) {
      target = sectionEl.querySelector(`[data-pi-scroll-anchor="${id.replace(/"/g, '\\"')}"]`);
    }
    return target;
  }

  function piDocTop(el) {
    if (!el) return 0;
    let top = 0;
    let node = el;
    while (node) {
      top += node.offsetTop || 0;
      node = node.offsetParent;
    }
    return top;
  }

  /** Scroll so product title → variants → bundles → ATC are in view (title at top). */
  function piScrollToPurchaseZone(sectionEl, anchorId, smooth) {
    const id = (anchorId || 'product-purchase').replace(/^#+/, '').trim();
    let startEl =
      $('[data-pi-purchase-start]', sectionEl) ||
      (id ? piResolveScrollTarget(sectionEl, id) : null) ||
      $('.pi-title', sectionEl);
    if (!startEl) return;

    const topSpace = piHeaderOffset() + 8;
    const scrollTop = Math.max(0, piDocTop(startEl) - topSpace);

    window.scrollTo({ top: scrollTop, behavior: smooth ? 'smooth' : 'auto' });
  }

  /** Bind scroll CTAs anywhere on the page (comparison, FAQ, etc.). */
  function initPagePiScroll(sectionEl) {
    const root = sectionEl || document.querySelector('.pi-section');
    if (!root) return;
    $$('[data-pi-scroll-target]', document).forEach(btn => {
      if (btn._piScrollBound) return;
      btn._piScrollBound = true;
      btn.addEventListener('click', e => {
        if (btn.tagName === 'A' || btn.tagName === 'BUTTON') e.preventDefault();
        piScrollToTarget(btn, root);
      });
    });
  }

  function piScrollToTarget(btn, sectionEl) {
    const raw = btn.getAttribute('data-pi-scroll-target') || '';
    const id = raw.replace(/^#+/, '').trim();
    if (!id) return;
    const smooth = btn.hasAttribute('data-pi-scroll-smooth');
    if (btn.hasAttribute('data-pi-scroll-purchase')) {
      piScrollToPurchaseZone(sectionEl, id, smooth);
      return;
    }
    const target = piResolveScrollTarget(sectionEl, id);
    if (!target) return;
    target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
  }

  let piIngredientsModalDepth = 0;
  function bumpPiIngredientsModal(delta) {
    piIngredientsModalDepth = Math.max(0, piIngredientsModalDepth + delta);
    document.body.classList.toggle('pi-ing-modal-open', piIngredientsModalDepth > 0);
    document.body.style.overflow = piIngredientsModalDepth > 0 ? 'hidden' : '';
  }

  /** Clear leftover overflow lock after Back / bfcache (default PDP ATC path). */
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    piIngredientsModalDepth = 0;
    document.body.classList.remove('pi-ing-modal-open');
    document.body.style.overflow = '';
  });
  window.addEventListener('popstate', () => {
    if (piIngredientsModalDepth > 0) return;
    if (document.body.style.overflow === 'hidden' && !document.querySelector('.pi-ing-modal.is-open, .pi-video-modal.is-open')) {
      document.body.style.overflow = '';
    }
  });

  /**
   * Bundle line total in cents — matches Shopify cart discount allocation
   * (discounted unit price rounded up, then × quantity).
   */
  function bundlePerUnitCents(unitPrice, disc) {
    if (!disc || disc <= 0) return unitPrice;
    return Math.ceil((unitPrice * (100 - disc)) / 100);
  }

  function bundleLineTotalCents(unitPrice, qty, disc) {
    const safeQty = qty > 0 ? qty : 1;
    return bundlePerUnitCents(unitPrice, disc) * safeQty;
  }

  /** Flat pack price in cents from a bundle card, or 0 when unset (PDP-V1 model). */
  function cardPackCents(card) {
    if (!card) return 0;
    const cents = parseInt(card.dataset.priceCents, 10);
    return Number.isFinite(cents) && cents > 0 ? cents : 0;
  }

  /* ── Shopify-compatible money formatter (handles all standard placeholders) ── */
  function escapeHtml(str) {
    return String(str ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents, fmt) {
    if (cents == null || isNaN(cents)) return '';
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    fmt = fmt || '${{amount}}';

    const value = cents / 100;
    const group = (n, sep, decSep, dp) => {
      const fixed = (dp === 0 ? Math.round(n) : n).toFixed(dp);
      const parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return parts.join(decSep);
    };

    const placeholders = {
      amount:                                    () => group(value, ',', '.', 2),
      amount_no_decimals:                        () => group(value, ',', '.', 0),
      amount_with_comma_separator:               () => group(value, '.', ',', 2),
      amount_no_decimals_with_comma_separator:   () => group(value, '.', ',', 0),
      amount_with_space_separator:               () => group(value, ' ', '.', 2),
      amount_no_decimals_with_space_separator:   () => group(value, ' ', '.', 0),
      amount_with_apostrophe_separator:          () => group(value, '\u0027', '.', 2),
      amount_with_period_and_space_separator:    () => group(value, ' ', '.', 2)
    };

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, name) => {
      const fn = placeholders[name];
      return fn ? fn() : group(value, ',', '.', 2);
    });
  }

  /** Matches Trust point dates to block min/max calendar days using the shopper’s local “today”. */
  function formatDeliveryEstimateDate(date, mode) {
    const m = mode || 'long_year';
    if (m === 'long') {
      return date.toLocaleDateString(undefined, { month: 'long', day: 'numeric' });
    }
    if (m === 'numeric') {
      return date.toLocaleDateString(undefined, { year: 'numeric', month: 'numeric', day: 'numeric' });
    }
    return date.toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' });
  }

  /** Recompute delivery-window copy for every `[data-pi-delivery]` under `root`. */
  function refreshDeliveryDateSpans(root) {
    $$('[data-pi-delivery]', root || document).forEach(el => {
      const min = parseInt(el.getAttribute('data-min'), 10);
      const max = parseInt(el.getAttribute('data-max'), 10);
      const minDays = Number.isFinite(min) ? min : 10;
      let maxDays = Number.isFinite(max) ? max : 15;
      if (maxDays < minDays) maxDays = minDays;
      const mode = el.getAttribute('data-format');
      const today = new Date();
      const start = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const addDays = (d, n) => {
        const r = new Date(d);
        r.setDate(r.getDate() + n);
        return r;
      };
      const minStr = formatDeliveryEstimateDate(addDays(start, minDays), mode);
      const maxStr = formatDeliveryEstimateDate(addDays(start, maxDays), mode);
      el.textContent = minStr === maxStr ? minStr : `${minStr} – ${maxStr}`;
    });
  }

  /* ═════════════════════════════════════════════════════════════
     SECTION CONTROLLER
  ═════════════════════════════════════════════════════════════ */
  class ProductInfoCustom {
    constructor(el) {
      this.el           = el;
      this.sectionId    = el.dataset.sectionId;
      this.productId    = parseInt(el.dataset.productId, 10);
      this.moneyFormat  = el.dataset.moneyFormat || '${{amount}}';
      this.enableBundleMix = String(el.dataset.enableBundleMix || 'true') === 'true';

      const dataNode = $('script[data-pi-product]', el);
      try {
        this.product = dataNode?.textContent
          ? JSON.parse(dataNode.textContent)
          : { variants: [] };
      } catch (_) {
        this.product = { variants: [] };
      }

      const defVariantId = parseInt(el.dataset.defaultVariantId, 10);
      this.state = {
        variant:        this.findVariantById(defVariantId) || this.product.variants[0],
        bundleQty:      1,
        bundleDiscount: 0,
        bundleEl:       null,
        bundleMix:      {},
        subscribed:     false,
        sellingPlanId:  el.dataset.defaultPlanId || null
      };

      this.form          = $('.pi-product-form', el);
      this.variantInput  = $('[data-pi-variant-input]', el);
      this.quantityInput = $('[data-pi-quantity-input]', el);
      this.bundlePropertyInput = $('[data-pi-bundle-property]', el);
      this.planInput     = $('[data-pi-plan-input]', el);
      this.atcBtn        = $('[data-pi-atc]', el);
      this.errorEl       = $('[data-pi-error]', el);
      this.soldOutLabelShown = false;
      this.soldOutPostedAt = 0;
      this.soldOutAttemptId = null;
      this.bundleMixWrap   = $('[data-pi-bundle-mix]', el);
      this.bundleMixToggle = $('[data-pi-bundle-mix-toggle]', el);
      this.bundleMixPanel  = $('[data-pi-bundle-mix-panel]', el);
      this.bundleMixHint   = $('[data-pi-bundle-mix-hint]', el);
      this.bundleMixStatus = $('[data-pi-bundle-mix-status]', el);
      this.bundleMixSummary = $('[data-pi-bundle-mix-summary]', el);
      this.bundleMixRows   = $$('[data-pi-bundle-mix-row]', el);

      this.init();
    }

    findVariantById(id) {
      if (!id) return null;
      const numericId = typeof id === 'string' ? parseInt(id, 10) : id;
      return this.product.variants.find(v => v.id === numericId) || null;
    }

    /** Max purchasable qty for one variant (Shopify inventory rules). */
    getMaxPurchasableQty(variant) {
      if (!variant || !variant.available) return 0;
      if (variant.inventory_management !== 'shopify') return Number.POSITIVE_INFINITY;
      if (variant.inventory_policy === 'continue') return Number.POSITIVE_INFINITY;
      const qty = parseInt(variant.inventory_quantity, 10);
      return Number.isFinite(qty) ? Math.max(0, qty) : 0;
    }

    getVariantInventoryError(variant, requestedQty) {
      if (!variant) return 'This item is unavailable.';
      const title = variant.title || 'This item';
      const max = this.getMaxPurchasableQty(variant);
      const qty = parseInt(requestedQty, 10) || 0;

      if (max === 0 || !variant.available) {
        return `${title} is sold out. Choose another scent or reduce your bundle.`;
      }
      if (Number.isFinite(max) && qty > max) {
        return `Only ${max} of ${title} ${max === 1 ? 'is' : 'are'} available. Reduce quantity to ${max} or fewer.`;
      }
      return null;
    }

    validateBundleMixInventory() {
      if (!this.isBundleMixEnabled()) return null;
      for (const item of this.getBundleMixItems()) {
        const variant = this.findVariantById(item.id);
        const err = this.getVariantInventoryError(variant, item.quantity);
        if (err) return err;
      }
      return null;
    }

    mixRequiresSellingPlan() {
      return !!(this.state.subscribed && this.subscribeBlock?.dataset?.state === 'enabled');
    }

    isVariantEligibleForMix(variant) {
      if (!variant || !variant.available) return false;
      if (this.getMaxPurchasableQty(variant) <= 0) return false;
      if (this.mixRequiresSellingPlan() && !this.getActivePlanIdForVariant(variant)) return false;
      return true;
    }

    getEligibleMixVariants() {
      return (this.product.variants || []).filter(v => this.isVariantEligibleForMix(v));
    }

    /** Spread bundle qty across in-stock (and subscription-eligible) variants for any product. */
    allocateDefaultBundleMixSmart() {
      const base = {};
      (this.product.variants || []).forEach(v => {
        base[String(v.id)] = 0;
      });

      const required = this.state.bundleQty;
      const eligible = this.getEligibleMixVariants();
      if (!eligible.length || required < 1) {
        this.state.bundleMix = base;
        return;
      }

      let remaining = required;
      const prefer = this.state.variant && this.isVariantEligibleForMix(this.state.variant)
        ? this.state.variant
        : eligible[0];

      if (prefer) {
        const maxForPrefer = this.getMaxPurchasableQty(prefer);
        const take = Math.min(remaining, Number.isFinite(maxForPrefer) ? maxForPrefer : remaining);
        if (take > 0) {
          base[String(prefer.id)] = take;
          remaining -= take;
        }
      }

      let guard = 0;
      let idx = 0;
      while (remaining > 0 && guard < required * eligible.length * 4) {
        const variant = eligible[idx % eligible.length];
        const key = String(variant.id);
        const current = base[key] || 0;
        const max = this.getMaxPurchasableQty(variant);
        if (!Number.isFinite(max) || current < max) {
          base[key] = current + 1;
          remaining -= 1;
        }
        idx += 1;
        guard += 1;
      }

      this.state.bundleMix = base;
    }

    allocateDefaultBundleMix() {
      this.allocateDefaultBundleMixSmart();
    }

    repairBundleMixIfNeeded() {
      if (!this.isBundleMixEnabled()) return;
      const required = this.state.bundleQty;
      const total = this.getBundleMixTotalQty();
      const inventoryErr = this.validateBundleMixInventory();
      const items = this.getBundleMixItems();
      const planErr = this.mixRequiresSellingPlan() && items.some(
        item => !this.getActivePlanIdForVariant(this.findVariantById(item.id))
      );

      if (!inventoryErr && !planErr && total === required) return;

      this.allocateDefaultBundleMixSmart();
      this.renderBundleMix();
      this.refreshAtcAvailability();
    }

    ensurePurchasableVariantSelected() {
      const current = this.state.variant;
      if (current && current.available && this.getMaxPurchasableQty(current) > 0) return;

      const fallback = this.getEligibleMixVariants()[0]
        || (this.product.variants || []).find(v => v.available);
      if (!fallback) return;

      this.state.variant = fallback;
      if (this.variantInput) this.variantInput.value = fallback.id;

      $$('.pi-variant-btn', this.el).forEach(btn => {
        const id = parseInt(btn.dataset.variantId, 10);
        btn.classList.toggle('is-active', id === fallback.id);
      });

      this.refreshSubscribeAvailability();
      this.syncSellingPlanInput();
      this.refreshPrices();
      this.syncIngredientsPopupImages();
    }

    syncBundleMixRowsFromProduct() {
      this.bundleMixRows.forEach(row => {
        const variant = this.findVariantById(parseInt(row.dataset.variantId, 10));
        if (!variant) return;
        row.dataset.variantAvailable = String(variant.available);
        if (variant.inventory_management === 'shopify') {
          row.dataset.variantInventory = String(variant.inventory_quantity ?? '');
        }
      });
    }

    async refreshProductAvailability() {
      if (this.isDesignMode()) return;

      const handle = this.product.handle || this.el.dataset.productHandle;
      if (!handle) return;

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const url = `${root}products/${encodeURIComponent(handle)}.js`;

      try {
        const res = await fetch(url, { credentials: 'same-origin' });
        if (!res.ok) return;
        const data = await res.json();
        if (!Array.isArray(data.variants)) return;

        const freshById = new Map(data.variants.map(v => [v.id, v]));
        this.product.variants = (this.product.variants || []).map(v => {
          const fresh = freshById.get(v.id);
          if (!fresh) return { ...v, available: false };
          const next = {
            ...v,
            available: !!fresh.available,
            price: typeof fresh.price === 'number' ? fresh.price : v.price,
            compare_at_price: typeof fresh.compare_at_price === 'number' ? fresh.compare_at_price : v.compare_at_price
          };
          if (typeof fresh.inventory_management === 'string') {
            next.inventory_management = fresh.inventory_management;
          }
          if (typeof fresh.inventory_policy === 'string') {
            next.inventory_policy = fresh.inventory_policy;
          }
          if (typeof fresh.inventory_quantity === 'number') {
            next.inventory_quantity = fresh.inventory_quantity;
          } else if (!fresh.available && next.inventory_management === 'shopify') {
            next.inventory_quantity = 0;
          }
          return next;
        });

        if (this.state.variant) {
          const updated = this.findVariantById(this.state.variant.id);
          if (updated) this.state.variant = updated;
        }

        this.ensurePurchasableVariantSelected();
        this.syncBundleMixRowsFromProduct();
        this.renderBundleMix();
        this.refreshAtcAvailability();
      } catch (e) {
        console.warn('[product-info-custom] availability refresh failed:', e);
      }
    }

    init() {
      this.initGallery();
      this.initVariantSelector();
      this.initBundles();
      this.initBundleMix();
      this.initSubscribe();
      this.initATC();
      this.initTestimonialCarousel();
      this.initAccordion();
      this.initVideoCarousel();
      refreshDeliveryDateSpans(this.el);
      this.initIngredientsPopup();
      this.syncIngredientsPopupImages();
      this.initStickyBundleBtn();

      this.ensurePurchasableVariantSelected();
      this.syncBundleMixRowsFromProduct();

      if ($('[data-pi-bundle]', this.el).length) {
        if (this.subscribeToggle) this.state.subscribed = !!this.subscribeToggle.checked;
        this.refreshPrices();
      }

      this.refreshAtcAvailability();
      this.refreshProductAvailability();
    }

    /* ─────────────────────────────────────────────────────────
       STICKY BUNDLE — show/hide bar (scroll handled by initPagePiScroll)
    ───────────────────────────────────────────────────────── */
    initStickyBundleBtn() {
      const bar = $('[data-pi-sticky-bundle]', this.el);
      if (!bar) return;

      const piShopifySection = this.el.closest('.shopify-section');
      const showAtId = (bar.getAttribute('data-pi-sticky-show-at') || 'how-it-works').replace(/^#+/, '').trim();

      const findShowAtTarget = () => {
        if (!showAtId) return null;
        let el = document.getElementById(showAtId);
        if (!el) {
          el = document.querySelector(`[data-pi-scroll-anchor="${showAtId.replace(/"/g, '\\"')}"]`);
        }
        return el;
      };

      bar.removeAttribute('hidden');

      const syncVisible = show => {
        const canRender = piStickyBarIsRenderable(bar);
        const visible = show && canRender;
        bar.classList.toggle('is-visible', visible);
        if (!visible) {
          document.documentElement.style.removeProperty('--pi-sticky-bundle-h');
          document.body.classList.remove('pi-has-sticky-bundle');
          return;
        }
        const h = bar.offsetHeight > 0 ? bar.offsetHeight : 72;
        document.documentElement.style.setProperty('--pi-sticky-bundle-h', `${h}px`);
        document.body.classList.toggle('pi-has-sticky-bundle', h > 0);
      };

      const updateVisibility = () => {
        const target = findShowAtTarget();
        if (!target) {
          syncVisible(false);
          return;
        }

        const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
        const headerOff = piHeaderOffset();
        const anchorTop = target.getBoundingClientRect().top + scrollY;

        // Passed this section while scrolling down (stays true when continuing further down).
        const hasReachedSection = scrollY + headerOff >= anchorTop;
        // Scrolled back up above the section anchor (only hide on upward scroll past it).
        const scrolledBackAboveSection = scrollY + headerOff < anchorTop;

        let stillInProductInfo = false;
        if (piShopifySection && showAtId !== 'product-purchase') {
          const piR = piShopifySection.getBoundingClientRect();
          stillInProductInfo = piR.bottom > window.innerHeight * 0.45 && piR.top < window.innerHeight * 0.85;
        }

        const show = hasReachedSection && !scrolledBackAboveSection && !stillInProductInfo;
        syncVisible(show);
      };

      const onScroll = () => updateVisibility();

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();

      const sectionId = bar.getAttribute('data-pi-section-id');
      const onUnload = ev => {
        const target = ev.target;
        if (!target || !sectionId) return;
        if (target.contains?.(bar) || target.querySelector?.(`[data-pi-section-id="${sectionId}"]`)) {
          document.body.classList.remove('pi-has-sticky-bundle');
          document.documentElement.style.removeProperty('--pi-sticky-bundle-h');
        }
      };
      document.addEventListener('shopify:section:unload', onUnload);
    }

    /* ─────────────────────────────────────────────────────────
       GALLERY
    ───────────────────────────────────────────────────────── */
    initGallery() {
      const gallery = $('.pi-gallery', this.el);
      if (!gallery) return;

      const VISIBLE_THUMBS = 5;

      const slides    = $$('.pi-gallery__slide', gallery);
      const thumbs    = $$('.pi-gallery__thumb', gallery);
      const track     = $('.pi-gallery__thumbs-track', gallery);
      const prevBtn   = $('.pi-gallery__arrow--prev', gallery);
      const nextBtn   = $('.pi-gallery__arrow--next', gallery);
      let current = 0;
      let stepPx = 0; // one thumbnail's height + row gap, recalculated on resize

      /* ── Thumbnail rail paging ──
         No visible scrollbar and no dedicated nav buttons: the track's
         max-height is capped to exactly VISIBLE_THUMBS items, and paging
         happens by clicking the last visible thumbnail of the current page
         (which reveals the next page), or via mouse wheel / touch scroll. */
      const getTrackGap = () => parseFloat(getComputedStyle(track).rowGap || getComputedStyle(track).gap || '6') || 6;

      const syncThumbsHeight = () => {
        if (!track || !thumbs.length) return;
        const rect = thumbs[0].getBoundingClientRect();
        if (rect.height <= 0) return;
        const gap = getTrackGap();
        stepPx = rect.height + gap;
        const maxH = stepPx * VISIBLE_THUMBS - gap;
        track.style.maxHeight = `${Math.round(maxH)}px`;
      };

      /** Scroll the rail so the page containing `idx` is visible (used after arrow nav / swipe). */
      const ensureActiveThumbVisible = (idx) => {
        if (!track || thumbs.length <= VISIBLE_THUMBS || !stepPx) return;
        const pageHeight = stepPx * VISIBLE_THUMBS;
        const targetTop = Math.floor(idx / VISIBLE_THUMBS) * pageHeight;
        if (Math.abs(track.scrollTop - targetTop) > 1) {
          track.scrollTo({ top: targetTop, behavior: 'smooth' });
        }
      };

      /** Clicking the last thumbnail of the current page reveals the next page. */
      const advancePageIfLastOfPage = (idx) => {
        if (!track || thumbs.length <= VISIBLE_THUMBS || !stepPx) return;
        const pageHeight = stepPx * VISIBLE_THUMBS;
        const pageIndex = Math.round(track.scrollTop / pageHeight);
        const lastIdxOfPage = Math.min(pageIndex * VISIBLE_THUMBS + VISIBLE_THUMBS - 1, thumbs.length - 1);
        if (idx === lastIdxOfPage && idx < thumbs.length - 1) {
          track.scrollTo({ top: (pageIndex + 1) * pageHeight, behavior: 'smooth' });
        }
      };

      const goTo = (idx) => {
        if (!slides.length) return;
        slides[current]?.classList.remove('is-active');
        thumbs[current]?.classList.remove('is-active');
        current = ((idx % slides.length) + slides.length) % slides.length;
        slides[current]?.classList.add('is-active');
        thumbs[current]?.classList.add('is-active');
        ensureActiveThumbVisible(current);
      };

      this._galleryGoTo = goTo;
      this._gallerySlides = slides;

      thumbs.forEach((t, i) => t.addEventListener('click', () => {
        goTo(i);
        advancePageIfLastOfPage(i);
      }));
      prevBtn?.addEventListener('click', () => goTo(current - 1));
      nextBtn?.addEventListener('click', () => goTo(current + 1));

      let startX = 0;
      const main = $('.pi-gallery__main', gallery);
      main?.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
      main?.addEventListener('touchend', e => {
        const diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
      });

      if (track && thumbs.length && 'ResizeObserver' in window) {
        const ro = new ResizeObserver(syncThumbsHeight);
        ro.observe(thumbs[0]);
        syncThumbsHeight();
      }

      // Land on the product’s default media order; variant images only after a click.
      goTo(0);
    }

    /** Match Shopify Admin “variant image” to a gallery slide (media id, then URL). */
    findGalleryIndexForVariant(variant) {
      const slides = this._gallerySlides || $$('.pi-gallery__slide', this.el);
      if (!variant || !slides.length) return -1;

      if (variant.featured_media_id != null && variant.featured_media_id !== '') {
        const id = String(variant.featured_media_id);
        const byId = slides.findIndex(s => String(s.dataset.mediaId) === id);
        if (byId >= 0) return byId;
      }

      const src = variant.featured_image_src;
      if (!src) return -1;
      const needle = this.galleryMediaKey(src);
      if (!needle) return -1;
      return slides.findIndex(s => {
        const img = s.querySelector('img');
        if (!img) return false;
        const key = this.galleryMediaKey(img.getAttribute('src') || img.currentSrc || img.src || '');
        return key && (key === needle || key.includes(needle) || needle.includes(key));
      });
    }

    galleryMediaKey(url) {
      if (!url) return '';
      try {
        const path = String(url).split('?')[0].split('#')[0];
        const file = path.split('/').pop() || '';
        return file.replace(/_\d+x\d*(@2x)?(\.[a-z0-9]+)$/i, '$2').toLowerCase();
      } catch (_) {
        return '';
      }
    }

    syncGalleryToVariant(variant) {
      if (typeof this._galleryGoTo !== 'function') return;
      const idx = this.findGalleryIndexForVariant(variant || this.state.variant);
      if (idx >= 0) this._galleryGoTo(idx);
    }

    /* ─────────────────────────────────────────────────────────
       VARIANT SELECTOR (single-option scent pills)
    ───────────────────────────────────────────────────────── */
    initVariantSelector() {
      const btns = $$('.pi-variant-btn', this.el);

      btns.forEach(btn => {
        btn.addEventListener('click', () => {
          if (btn.disabled || btn.classList.contains('is-unavailable')) return;
          const variantId = parseInt(btn.dataset.variantId, 10);
          const variant = this.findVariantById(variantId);
          if (!variant || !variant.available) return;

          btns.forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');

          this.state.variant = variant;
          if (this.variantInput) this.variantInput.value = variant.id;

          if (this.isBundleMixEnabled() && this.getBundleMixTotalQty() === 0) {
            this.allocateDefaultBundleMix();
            this.renderBundleMix();
          }

          this.refreshSubscribeAvailability();
          this.syncSellingPlanInput();
          this.refreshAtcAvailability();
          this.refreshPrices();
          this.syncIngredientsPopupImages();
          this.syncGalleryToVariant(variant);
        });
      });
    }

    /** Keep ingredients modal image in sync when “variant” source is used. */
    syncIngredientsPopupImages() {
      const v = this.state.variant;
      const fromVariant = v && v.featured_image_src ? v.featured_image_src : '';
      const fallback = this.product.featured_image_src || '';
      const url = fromVariant || fallback;
      $$('.pi-ing-modal__img[data-pi-ing-img-mode="variant"]', this.el).forEach(img => {
        if (!url) return;
        img.src = url;
        img.removeAttribute('srcset');
      });
    }

    /* ─────────────────────────────────────────────────────────
       BUNDLES (cart_quantity × discount_percent)
    ───────────────────────────────────────────────────────── */
    initBundles() {
      const cards = $$('[data-pi-bundle]', this.el);
      cards.forEach(card => card.addEventListener('click', () => this.selectBundle(card)));

      const def = cards.find(c => c.dataset.default === 'true') || cards[0];
      if (def) this.selectBundle(def);
    }

    selectBundle(card) {
      $$('[data-pi-bundle]', this.el).forEach(c => c.classList.remove('is-active'));
      card.classList.add('is-active');

      this.state.bundleQty       = parseInt(card.dataset.cartQuantity, 10) || 1;
      this.state.bundleDiscount  = parseFloat(card.dataset.discountPercent) || 0;
      this.state.bundlePackCents = cardPackCents(card);
      this.state.bundleEl        = card;

      if (this.quantityInput) this.quantityInput.value = this.state.bundleQty;
      if (this.bundlePropertyInput) this.bundlePropertyInput.value = String(this.state.bundleQty);
      this.syncBundleMixForBundle();
      this.refreshPrices();
    }

    initBundleMix() {
      if (!this.bundleMixWrap || !this.bundleMixToggle || !this.bundleMixPanel) return;
      if (!this.enableBundleMix) {
        this.bundleMixWrap.hidden = true;
        this.bundleMixToggle.checked = false;
        return;
      }

      this.bundleMixToggle.checked = false;
      this.bundleMixToggle.addEventListener('change', () => {
        if (this.bundleMixToggle.checked) {
          this.allocateDefaultBundleMix();
        }
        this.renderBundleMix();
        this.refreshAtcAvailability();
      });

      this.bundleMixRows.forEach(row => {
        row.addEventListener('click', e => {
          const btn = e.target.closest('[data-pi-bundle-mix-action]');
          if (!btn) return;
          const variantId = parseInt(row.dataset.variantId, 10);
          const action = btn.dataset.piBundleMixAction;
          this.adjustBundleMixQty(variantId, action === 'increment' ? 1 : -1);
        });
      });

      this.syncBundleMixForBundle();
    }

    isBundleMixEnabled() {
      return !!(this.bundleMixToggle && this.bundleMixToggle.checked && this.state.bundleQty > 1);
    }

    getBundleMixTotalQty() {
      return Object.values(this.state.bundleMix || {}).reduce((sum, n) => sum + (parseInt(n, 10) || 0), 0);
    }

    syncBundleMixForBundle() {
      if (!this.bundleMixWrap || !this.bundleMixToggle || !this.bundleMixPanel) return;
      if (!this.enableBundleMix) {
        this.bundleMixWrap.hidden = true;
        this.bundleMixToggle.checked = false;
        return;
      }

      const canMix = this.state.bundleQty > 1;
      this.bundleMixWrap.hidden = !canMix;
      if (!canMix) {
        this.bundleMixToggle.checked = false;
      } else if (this.isBundleMixEnabled() && this.getBundleMixTotalQty() !== this.state.bundleQty) {
        this.allocateDefaultBundleMix();
      }
      this.renderBundleMix();
      this.refreshAtcAvailability();
    }

    adjustBundleMixQty(variantId, delta) {
      const key = String(variantId);
      const current = parseInt(this.state.bundleMix[key], 10) || 0;
      const next = Math.max(0, current + delta);
      const currentTotal = this.getBundleMixTotalQty();
      const nextTotal = currentTotal - current + next;

      if (nextTotal > this.state.bundleQty) return;

      if (delta > 0) {
        const variant = this.findVariantById(variantId);
        const err = this.getVariantInventoryError(variant, next);
        if (err) return;
      }

      this.state.bundleMix[key] = next;
      this.renderBundleMix();
      this.refreshAtcAvailability();
    }

    getBundleMixItems() {
      if (!this.isBundleMixEnabled()) return [];
      return Object.entries(this.state.bundleMix || {})
        .map(([id, qty]) => ({ id: parseInt(id, 10), quantity: parseInt(qty, 10) || 0 }))
        .filter(item => item.id && item.quantity > 0);
    }

    getBundleMixSummaryText() {
      const parts = this.getBundleMixItems().map(item => {
        const variant = this.findVariantById(item.id);
        const title = variant ? variant.title : `Variant ${item.id}`;
        return `${item.quantity} ${title}`;
      });
      return parts.join(', ');
    }

    renderBundleMix() {
      if (!this.bundleMixWrap || !this.bundleMixToggle || !this.bundleMixPanel) return;

      const active = this.isBundleMixEnabled();
      this.bundleMixPanel.hidden = !active;
      this.bundleMixWrap.classList.toggle('is-open', active);
      if (!active) {
        if (this.bundleMixSummary) {
          this.bundleMixSummary.hidden = true;
          this.bundleMixSummary.textContent = '';
        }
        return;
      }

      const required = this.state.bundleQty;
      const selected = this.getBundleMixTotalQty();
      const remaining = Math.max(0, required - selected);

      this.bundleMixRows.forEach(row => {
        const variantId = row.dataset.variantId;
        const variant = this.findVariantById(parseInt(variantId, 10));
        const missingPlan = this.mixRequiresSellingPlan() && !this.getActivePlanIdForVariant(variant);
        const maxQty = this.getMaxPurchasableQty(variant);
        const inventoryBlocked = Number.isFinite(maxQty) && maxQty === 0;
        const unavailable = !variant || !variant.available || missingPlan || inventoryBlocked;
        const count = parseInt(this.state.bundleMix[variantId], 10) || 0;
        const decBtn = row.querySelector('[data-pi-bundle-mix-action="decrement"]');
        const incBtn = row.querySelector('[data-pi-bundle-mix-action="increment"]');
        const countEl = row.querySelector('[data-pi-bundle-mix-count]');
        const atInventoryCap = Number.isFinite(maxQty) && count >= maxQty;

        row.classList.toggle('is-unavailable', unavailable);
        if (countEl) countEl.textContent = String(count);
        if (decBtn) decBtn.disabled = count <= 0;
        if (incBtn) incBtn.disabled = unavailable || selected >= required || atInventoryCap;
      });

      if (this.bundleMixHint) {
        this.bundleMixHint.textContent = `Select quantities that add up to ${required}.`;
      }
      if (this.bundleMixStatus) {
        this.bundleMixStatus.textContent = remaining === 0
          ? `Perfect: ${selected}/${required} selected.`
          : `${selected}/${required} selected. ${remaining} remaining.`;
      }
      if (this.bundleMixSummary) {
        const summary = this.getBundleMixSummaryText();
        this.bundleMixSummary.hidden = !summary;
        this.bundleMixSummary.textContent = summary ? `Bundle mix: ${summary}` : '';
      }
    }

    /* ─────────────────────────────────────────────────────────
       SUBSCRIBE & SAVE (native Shopify Selling Plans + manual fallback)
       ─────────────────────────────────────────────────────────
       Three render states (Liquid sets data-state on the block):
         enabled  → product has Selling Plans + variant has an allocation.
                    Toggle on captures real plan_id, applies real
                    allocation price, customer gets a real subscription.
         manual   → product has NO Selling Plans yet (or variant has none).
                    Toggle is interactive but visual only: applies
                    `manual_percent_off` as a visual discount, form
                    submits without selling_plan, no real subscription.
         disabled → toggle non-interactive, visually greyed out.
    ───────────────────────────────────────────────────────── */
    initSubscribe() {
      this.subscribeBlock  = $('[data-pi-subscribe]', this.el);
      if (!this.subscribeBlock) return;

      this.subscribeToggle = $('[data-pi-subscribe-toggle]', this.subscribeBlock);
      if (!this.subscribeToggle) return;

      this.manualPlanId = (this.subscribeBlock.dataset.manualPlanId || '').trim();
      this.preferredPlanName = (this.subscribeBlock.dataset.preferredPlanName || '').trim().toLowerCase();
      this.manualDiscount = parseFloat(this.subscribeBlock.dataset.manualDiscount) || 0;

      this.subscribeToggle.addEventListener('change', () => {
        this.state.subscribed = this.subscribeToggle.checked;
        this.renderBundleMix();
        this.syncSellingPlanInput();
        this.refreshPrices();
        this.refreshAtcAvailability();
      });

      this.refreshSubscribeAvailability();
      this.syncSellingPlanInput();
    }

    syncSellingPlanInput() {
      if (!this.planInput) return;
      const subscribed = !!(this.subscribeToggle && this.subscribeToggle.checked);
      this.subscribeBlock?.classList.toggle('is-active', subscribed);

      if (!subscribed) {
        this.state.sellingPlanId = null;
        this.planInput.value = '';
        this.planInput.disabled = true;
        return;
      }

      const planId = this.getActivePlanId();
      this.state.sellingPlanId = planId;
      if (planId) {
        this.planInput.value = String(planId);
        this.planInput.disabled = false;
      } else {
        // Manual / preview mode — no real plan, keep selling_plan field empty/disabled
        this.planInput.value = '';
        this.planInput.disabled = true;
      }
    }

    getActivePlanIdForVariant(variant) {
      const v = variant;
      if (!v || !v.selling_plan_allocations || v.selling_plan_allocations.length === 0) return null;

      if (this.manualPlanId) {
        const manualId = parseInt(this.manualPlanId, 10);
        const match = v.selling_plan_allocations.find(a => parseInt(a.selling_plan_id, 10) === manualId);
        if (match) return match.selling_plan_id;
      }

      if (this.preferredPlanName) {
        const matchByName = v.selling_plan_allocations.find(a => {
          const planName = (a.selling_plan_name || '').trim().toLowerCase();
          return planName.includes(this.preferredPlanName);
        });
        if (matchByName) return matchByName.selling_plan_id;
      }

      return v.selling_plan_allocations[0].selling_plan_id;
    }

    getActivePlanId() {
      return this.getActivePlanIdForVariant(this.state.variant);
    }

    refreshSubscribeAvailability() {
      if (!this.subscribeBlock || !this.subscribeToggle) return;

      const state = this.subscribeBlock.dataset.state;
      // In `manual` and `disabled` Liquid modes, JS doesn't override interactivity —
      // the Liquid template already sets the correct disabled-state.
      if (state === 'manual' || state === 'disabled') return;

      // `enabled` mode: gate availability per variant. If the active variant has
      // no selling-plan allocation, disable the toggle until a different variant
      // is selected.
      const v = this.state.variant;
      const hasPlan = v && v.selling_plan_allocations && v.selling_plan_allocations.length > 0;

      if (!hasPlan) {
        this.subscribeBlock.classList.add('is-disabled');
        this.subscribeToggle.disabled = true;
        if (this.subscribeToggle.checked) {
          this.subscribeToggle.checked = false;
          this.subscribeToggle.dispatchEvent(new Event('change'));
        }
      } else {
        this.subscribeBlock.classList.remove('is-disabled');
        this.subscribeToggle.disabled = false;
      }

      this.syncSellingPlanInput();
    }

    /** Variant base unit price in cents (Markets) for bundle math — respects subscribe + selected plan. */
    getBundleBaseUnitCents(variant) {
      if (!variant) return 0;
      if (!this.state.subscribed) return variant.price;

      const allocs = variant.selling_plan_allocations;
      if (allocs && allocs.length > 0) {
        const pid = this.getActivePlanId();
        if (pid != null) {
          const match = allocs.find(a => String(a.selling_plan_id) === String(pid));
          if (match) return match.price;
        }
        return allocs[0].price;
      }
      if (this.manualDiscount > 0) {
        return Math.round(variant.price * (100 - this.manualDiscount) / 100);
      }
      return variant.price;
    }

    /* ─────────────────────────────────────────────────────────
       PRICE REFRESH (Markets-safe — uses variant.price in
       active-currency cents from the embedded product JSON)
    ───────────────────────────────────────────────────────── */
    refreshPrices() {
      const v = this.state.variant;
      if (!v) return;

      const unitPrice = this.getBundleBaseUnitCents(v);
      const listUnit = v.price || 0;

      $$('[data-pi-bundle]', this.el).forEach(card => {
        const qty   = parseInt(card.dataset.cartQuantity, 10) || 1;
        const disc  = parseFloat(card.dataset.discountPercent) || 0;
        const total = listUnit * qty;
        const final = this.packTotalCents(card, unitPrice, qty, disc);
        const perCents = qty > 0 ? Math.round(final / qty) : final;

        const priceEl   = $('[data-pi-bundle-price]', card);
        const compareEl = $('[data-pi-bundle-compare]', card);
        const perEl     = $('[data-pi-bundle-per-unit]', card);

        if (priceEl) priceEl.textContent = formatMoney(final, this.moneyFormat);
        if (compareEl && total > final) compareEl.textContent = formatMoney(total, this.moneyFormat);
        if (perEl) {
          const label = String(card.dataset.piPerUnitLabel || 'stick').trim() || 'stick';
          perEl.textContent = `${formatMoney(perCents, this.moneyFormat)} / ${label}`;
        }
      });

      const activeCard = this.state.bundleEl;
      if (activeCard) {
        const final = this.packTotalCents(
          activeCard,
          unitPrice,
          this.state.bundleQty,
          this.state.bundleDiscount
        );

        const atcPriceEl = $('[data-pi-atc-price]', this.el);
        if (atcPriceEl) atcPriceEl.textContent = formatMoney(final, this.moneyFormat);
      }
    }

    /**
     * Pack total in cents. A flat pack price wins; when subscribed it is scaled
     * by the selling plan's ratio so the plan discount still applies (PDP-V1).
     * Falls back to the older ceil(unit x (100 - disc)) x qty model.
     */
    packTotalCents(card, unitPrice, qty, disc) {
      const packCents = cardPackCents(card);
      if (!packCents) return bundleLineTotalCents(unitPrice, qty, disc);

      const listUnit = this.state.variant ? this.state.variant.price || 0 : 0;
      if (this.state.subscribed && listUnit > 0 && unitPrice !== listUnit) {
        return Math.round((packCents * unitPrice) / listUnit);
      }
      return packCents;
    }

    /* ─────────────────────────────────────────────────────────
       ADD TO CART
    ───────────────────────────────────────────────────────── */
    initATC() {
      if (!this.form || !this.atcBtn) return;
      this.form.addEventListener('submit', e => {
        e.preventDefault();
        if (this.isSoldOutMode()) {
          this.handleSoldOutClick();
          return;
        }
        this.submitATC();
      });
      this.el.querySelectorAll('[data-pi-notify-submit]').forEach(button => {
        button.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();
          const form = button.closest('[data-pi-notify-form]');
          this.submitSoldOutEmail(form);
        });
      });
      this.el.querySelectorAll('[data-pi-notify-email]').forEach(input => {
        input.addEventListener('keydown', e => {
          if (e.key !== 'Enter') return;
          e.preventDefault();
          e.stopPropagation();
          const form = input.closest('[data-pi-notify-form]');
          this.submitSoldOutEmail(form);
        });
      });
      this.refreshAtcAvailability();
    }

    isSoldOutMode() {
      return this.el?.dataset?.soldOut === 'true';
    }

    bundleSummary() {
      const bundleName = this.state.bundleEl?.dataset?.piBuildName || this.state.bundleEl?.dataset?.buildName || '';
      let scents = [];
      if (this.isBundleMixEnabled()) {
        scents = this.getBundleMixItems().map(item => {
          const variant = this.findVariantById(item.id);
          const name = variant?.title || item.id;
          return `${item.quantity} x ${name}`;
        });
      } else {
        const variant = this.state.variant;
        if (variant) {
          const units = this.state.bundleQty || 1;
          scents = [`${units} x ${variant.title}`];
        }
      }
      return [bundleName, scents.join(', ')].filter(Boolean).join(' — ');
    }

    purchaseChoice() {
      const subscribeOn =
        this.state.subscribed && this.subscribeBlock?.dataset?.state === 'enabled';
      if (!subscribeOn) {
        return 'One-time purchase';
      }
      const heading = this.subscribeBlock?.querySelector('.pi-subscribe__heading');
      const title = (heading && heading.textContent.trim()) || 'Subscribe & Save';
      return title;
    }

    async postAtcAttempt(extra) {
      const api = (this.el?.dataset?.atcApi || 'https://ss-review-import.fly.dev').replace(/\/$/, '');
      const shop = this.el?.dataset?.shop || (window.Shopify && window.Shopify.shop) || '';
      const body = {
        shop,
        productId: String(this.product?.id || this.el?.dataset?.productId || ''),
        productTitle: this.product?.title || '',
        bundleSummary: this.bundleSummary(),
        purchaseChoice: this.purchaseChoice(),
        pageUrl: window.location.href,
        ...extra
      };
      const response = await fetch(`${api}/api/public/atc-attempts`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok || !data.ok) {
        throw new Error(data.message || 'Could not save that click.');
      }
      return data;
    }

    setError(msg) {
      if (this.errorEl) this.errorEl.textContent = msg || '';
    }

    showSoldOutLabel() {
      this.soldOutLabelShown = true;
      const next = this.el?.dataset?.soldOutClicked || 'Temporarily sold out';
      if (!this.atcBtn) return;
      const label = this.atcBtn.querySelector('[data-pi-atc-label]');
      if (label) label.textContent = next;
    }

    async handleSoldOutClick() {
      this.showSoldOutLabel();
      const now = Date.now();
      if (this.soldOutPostedAt && now - this.soldOutPostedAt < 1200) {
        this.revealNotify();
        return;
      }
      this.soldOutPostedAt = now;
      this.setError('');
      try {
        const data = await this.postAtcAttempt({});
        this.soldOutAttemptId = data.id;
        this.revealNotify();
      } catch (err) {
        this.setError(err.message || 'Could not save that click.');
      }
    }

    revealNotify() {
      if (this.el?.dataset?.askEmail !== 'true') return;
      this.el.querySelectorAll('[data-pi-notify]').forEach(el => {
        el.hidden = false;
      });
    }

    async submitSoldOutEmail(form) {
      if (!form) return;
      const input = form.querySelector('[data-pi-notify-email]');
      const email = input ? String(input.value || '').trim() : '';
      if (!email || !this.soldOutAttemptId) return;
      const button = form.querySelector('button');
      if (button) button.disabled = true;
      this.setError('');
      try {
        await this.postAtcAttempt({ attemptId: this.soldOutAttemptId, email });
        const wrap = form.closest('[data-pi-notify]');
        const prompt = wrap?.querySelector('.pi-notify__prompt');
        const success = wrap?.querySelector('[data-pi-notify-success]');
        if (prompt) prompt.hidden = true;
        form.hidden = true;
        if (success) {
          success.hidden = false;
          success.textContent =
            this.el?.dataset?.notifySuccess || "You're on the list. We'll email you when it's back.";
        }
      } catch (err) {
        if (button) button.disabled = false;
        this.setError(err.message || 'Could not save that email.');
      }
    }

    setAtcLoading(loading) {
      if (!this.atcBtn) return;
      const labelEl = $('[data-pi-atc-label]', this.atcBtn);
      const sepEl = $('[data-pi-atc-sep]', this.atcBtn);
      const priceEl = $('[data-pi-atc-price]', this.atcBtn);

      if (loading) {
        this.atcBtn.classList.add('pi-atc-btn--loading');
        this.atcBtn.disabled = true;
        this.atcBtn.setAttribute('aria-busy', 'true');
        if (labelEl) labelEl.textContent = this.atcBtn.dataset.textLoading || 'Adding…';
        if (sepEl) sepEl.hidden = true;
        if (priceEl) priceEl.hidden = true;
        return;
      }

      this.atcBtn.classList.remove('pi-atc-btn--loading');
      this.atcBtn.removeAttribute('aria-busy');
      if (sepEl) sepEl.hidden = false;
      if (priceEl) priceEl.hidden = false;
    }

    waitForCartDrawerOpen(timeoutMs = 6000) {
      return new Promise(resolve => {
        const drawer = document.querySelector('cart-drawer-component');
        const dialog =
          drawer?.querySelector?.('[data-testid="cart-drawer-dialog"]') ||
          drawer?.querySelector?.('dialog');

        if (dialog?.open) {
          resolve(true);
          return;
        }

        let settled = false;
        const finish = ok => {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          clearInterval(poll);
          drawer?.removeEventListener('dialog:open', onOpen);
          resolve(ok);
        };

        const onOpen = () => finish(true);
        drawer?.addEventListener('dialog:open', onOpen);
        const poll = setInterval(() => {
          if (dialog?.open) finish(true);
        }, 40);
        const timer = setTimeout(() => finish(false), timeoutMs);
      });
    }

    refreshAtcAvailability() {
      if (!this.atcBtn) return;
      if (this.atcBtn.classList.contains('pi-atc-btn--loading')) return;

      const labelEl = $('[data-pi-atc-label]', this.atcBtn);
      const sepEl   = $('[data-pi-atc-sep]', this.atcBtn);
      const priceEl = $('[data-pi-atc-price]', this.atcBtn);

      if (this.isDesignMode()) {
        this.atcBtn.disabled = false;
        this.atcBtn.classList.remove('is-soldout');
        if (this.isSoldOutMode()) {
          if (labelEl && !this.soldOutLabelShown) {
            labelEl.textContent = this.el?.dataset?.soldOutLabel || 'Temporarily sold out';
          }
          if (sepEl)   sepEl.style.display   = 'none';
          if (priceEl) priceEl.style.display = 'none';
          return;
        }
        if (labelEl) labelEl.textContent = this.atcBtn.dataset.textAvailable;
        if (sepEl)   sepEl.style.display   = '';
        if (priceEl) priceEl.style.display = '';
        return;
      }

      const v = this.state.variant;

      let mixInvalid = false;
      if (this.isBundleMixEnabled()) {
        const items = this.getBundleMixItems();
        const total = items.reduce((sum, item) => sum + item.quantity, 0);
        const allAvailable = items.every(item => {
          const variant = this.findVariantById(item.id);
          return !!(variant && variant.available && this.getMaxPurchasableQty(variant) >= item.quantity);
        });
        const needsPlan = this.state.subscribed && this.subscribeBlock?.dataset?.state === 'enabled';
        const allHavePlans = !needsPlan || items.every(item => {
          const variant = this.findVariantById(item.id);
          return !!this.getActivePlanIdForVariant(variant);
        });
        mixInvalid = total !== this.state.bundleQty || !allAvailable || items.length === 0 || !allHavePlans;
      }

      const singleInventoryErr = !this.isBundleMixEnabled()
        ? this.getVariantInventoryError(v, this.state.bundleQty || 1)
        : this.validateBundleMixInventory();

      const available = !!(v && v.available && !mixInvalid && !singleInventoryErr);

      if (this.isSoldOutMode()) {
        this.atcBtn.disabled = !available;
        this.atcBtn.classList.remove('is-soldout');
        if (labelEl && !this.soldOutLabelShown) {
          labelEl.textContent = this.el?.dataset?.soldOutLabel || 'Temporarily sold out';
        }
        if (sepEl)   sepEl.style.display   = 'none';
        if (priceEl) priceEl.style.display = 'none';
        return;
      }

      if (!available) {
        this.atcBtn.disabled = true;
        this.atcBtn.classList.add('is-soldout');
        if (labelEl) {
          labelEl.textContent = singleInventoryErr
            || (mixInvalid ? 'Complete bundle selection' : this.atcBtn.dataset.textSoldout);
        }
        if (sepEl)   sepEl.style.display   = 'none';
        if (priceEl) priceEl.style.display = 'none';
      } else {
        this.atcBtn.disabled = false;
        this.atcBtn.classList.remove('is-soldout');
        if (labelEl) labelEl.textContent = this.atcBtn.dataset.textAvailable;
        if (sepEl)   sepEl.style.display   = '';
        if (priceEl) priceEl.style.display = '';
      }
    }

    getCurrentCartCount() {
      const icon = document.querySelector('cart-icon');
      const n = icon ? Number(icon.currentCartCount) : NaN;
      return Number.isFinite(n) ? n : 0;
    }

    getCartSectionIds() {
      const ids = [];
      document.querySelectorAll('cart-items-component').forEach(el => {
        if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
      });
      return ids;
    }

    isDesignMode() {
      return typeof Shopify !== 'undefined' && !!Shopify.designMode;
    }

    async fetchWithEditorTimeout(url, options, timeoutMs = 5000) {
      const controller = new AbortController();
      const timer = window.setTimeout(() => controller.abort(), timeoutMs);
      try {
        return await fetch(url, { ...options, signal: controller.signal });
      } finally {
        window.clearTimeout(timer);
      }
    }

    /** Single fast cart/add attempt for theme editor (no retry chains). */
    async postCartAddEditorFast(items, timeoutMs = 5000) {
      const minimal = this.stripSellingPlansFromItems(this.stripPropertiesFromItems(items || []));
      if (!minimal.length) return { ok: false, apiMsg: 'No items to add' };

      try {
        const res = await this.fetchWithEditorTimeout(
          this.getCartAddUrl(),
          {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items: minimal })
          },
          timeoutMs
        );
        const data = await res.json().catch(() => ({}));
        const ok = res.ok && !this.isCartAddError(data);
        return {
          ok,
          data,
          addedQty: minimal.reduce((sum, item) => sum + (parseInt(item.quantity, 10) || 0), 0),
          apiMsg: this.getCartAddErrorMessage(data)
        };
      } catch (err) {
        const timedOut = err && err.name === 'AbortError';
        return { ok: false, apiMsg: timedOut ? 'Cart request timed out' : '' };
      }
    }

    async fetchEditorCartFast(timeoutMs = 4000) {
      const cartUrl =
        (typeof window !== 'undefined' && window.Theme && window.Theme.routes && window.Theme.routes.cart_url) ||
        (window.routes && window.routes.cart_url) ||
        '/cart';
      const cartJs = cartUrl.endsWith('.js') ? cartUrl : `${cartUrl.replace(/\/$/, '')}.js`;
      try {
        const res = await this.fetchWithEditorTimeout(
          cartJs,
          { credentials: 'same-origin', headers: { Accept: 'application/json' } },
          timeoutMs
        );
        if (!res.ok) return null;
        return await res.json();
      } catch (_) {
        return null;
      }
    }

    isCartAddError(data) {
      if (!data || typeof data !== 'object') return false;
      if (data.errors) return true;
      const status = Number(data.status);
      return Number.isFinite(status) && status >= 400;
    }

    getCartAddErrorMessage(data) {
      if (!data || typeof data !== 'object') return '';
      if (typeof data.description === 'string' && data.description.trim()) return data.description.trim();
      if (typeof data.message === 'string' && data.message.trim()) return data.message.trim();
      if (typeof data.errors === 'string' && data.errors.trim()) return data.errors.trim();
      return '';
    }

    formatCartAddError(apiMsg) {
      if (!apiMsg) return 'Failed to add to cart';
      if (/sold out/i.test(apiMsg)) {
        return 'One or more selected scents are out of stock. Try a different scent, reduce quantities, or restock in Shopify Admin → Products.';
      }
      return apiMsg;
    }

    async fetchCartSectionsForEditor(sectionIds, sectionsUrl) {
      if (!sectionIds.length) return null;
      const base = sectionsUrl || window.location.pathname;
      try {
        const res = await fetch(
          `${base}?sections=${encodeURIComponent(sectionIds.join(','))}`,
          { credentials: 'same-origin', headers: { Accept: 'application/json' } }
        );
        if (!res.ok) return null;
        const data = await res.json().catch(() => null);
        return data && typeof data === 'object' ? data : null;
      } catch (e) {
        console.warn('[product-info-custom] editor cart section fetch failed:', e);
        return null;
      }
    }

    buildSectionsPayload(sectionIds) {
      if (!sectionIds.length) return {};
      return {
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      };
    }

    buildEditorSectionsPayload(sectionIds) {
      if (!sectionIds.length) return {};
      return {
        sections: sectionIds.join(','),
        sections_url: window.location.pathname
      };
    }

    getCartAddUrl() {
      const url =
        (typeof window !== 'undefined' && window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) ||
        (window.routes && window.routes.cart_add_url) ||
        '/cart/add';
      return url.endsWith('.js') ? url : `${url.replace(/\/$/, '')}.js`;
    }

    async postCartAdd(payload) {
      const res = await fetch(this.getCartAddUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const data = await res.json().catch(() => ({}));
      const ok = res.ok && !this.isCartAddError(data);
      return { ok, data, status: res.status, apiMsg: this.getCartAddErrorMessage(data) };
    }

    /** FormData cart add — more reliable in the theme editor preview iframe. */
    async postCartAddFormData(item) {
      const formData = new FormData();
      formData.append('form_type', 'product');
      formData.append('utf8', '✓');
      formData.append('id', String(item.id));
      formData.append('quantity', String(parseInt(item.quantity, 10) || 1));

      const urls = [this.getCartAddUrl()];
      const nonJs = this.getCartAddUrl().replace(/\.js$/, '');
      if (nonJs && nonJs !== urls[0]) urls.push(nonJs);

      let lastResult = { ok: false, data: {}, status: 0, apiMsg: '' };

      for (const url of urls) {
        const res = await fetch(url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json'
          },
          body: formData
        });

        const data = await res.json().catch(() => ({}));
        const ok = res.ok && !this.isCartAddError(data);
        lastResult = { ok, data, status: res.status, apiMsg: this.getCartAddErrorMessage(data) };
        if (ok) return lastResult;
      }

      return lastResult;
    }

    isSoldOutApiMessage(msg) {
      return /sold out|out of stock|unavailable/i.test(String(msg || ''));
    }

    async fetchEditorCart() {
      const cartUrl =
        (typeof window !== 'undefined' && window.Theme && window.Theme.routes && window.Theme.routes.cart_url) ||
        (window.routes && window.routes.cart_url) ||
        '/cart';
      const cartJs = cartUrl.endsWith('.js') ? cartUrl : `${cartUrl.replace(/\/$/, '')}.js`;
      try {
        const res = await fetch(cartJs, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (!res.ok) return null;
        return await res.json();
      } catch (_) {
        return null;
      }
    }

    async fetchEditorAvailableVariantIds() {
      const fallback = (this.product.variants || []).map(v => v?.id).filter(Boolean);
      const handle = this.product.handle || this.el.dataset.productHandle;
      if (!handle) return fallback;

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      try {
        const res = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (!res.ok) return fallback;
        const data = await res.json();
        const ids = (data.variants || []).map(v => v?.id).filter(Boolean);
        return ids.length ? ids : fallback;
      } catch (_) {
        return fallback;
      }
    }

    buildEditorCartLines(preferredItems, availableIds, targetQty) {
      const poolIds = availableIds.length
        ? availableIds
        : (this.product.variants || []).map(v => v.id).filter(Boolean);
      const available = new Set(poolIds);
      const lines = [];
      let remaining = Math.max(1, targetQty);

      (preferredItems || []).forEach(item => {
        if (!item?.id || !available.has(item.id)) return;
        const want = parseInt(item.quantity, 10) || 0;
        const take = Math.min(remaining, want);
        if (take < 1) return;
        lines.push({ id: item.id, quantity: take });
        remaining -= take;
      });

      const pool = availableIds.length
        ? availableIds
        : (this.product.variants || []).map(v => v.id);
      let idx = 0;
      let guard = 0;
      while (remaining > 0 && pool.length && guard < targetQty * pool.length * 2) {
        const id = pool[idx % pool.length];
        const row = lines.find(line => line.id === id);
        if (row) row.quantity += 1;
        else lines.push({ id, quantity: 1 });
        remaining -= 1;
        idx += 1;
        guard += 1;
      }

      return lines;
    }

    async addEditorLinesUnitByUnit(lines) {
      let addedQty = 0;
      let lastData = null;
      let lastApiMsg = '';

      for (const item of lines) {
        const qty = parseInt(item.quantity, 10) || 0;
        if (!item.id || qty < 1) continue;

        for (let i = 0; i < qty; i++) {
          const result = await this.postCartAddFormData({ id: item.id, quantity: 1 });
          if (!result.ok) {
            lastApiMsg = result.apiMsg || lastApiMsg;
            if (this.isSoldOutApiMessage(result.apiMsg)) continue;
            continue;
          }
          addedQty += 1;
          lastData = result.data;
        }
      }

      return { addedQty, lastData, lastApiMsg };
    }

    async addEditorAnyAvailableVariants(targetQty) {
      let addedQty = 0;
      let lastData = null;
      let lastApiMsg = '';
      const availableIds = await this.fetchEditorAvailableVariantIds();
      const availSet = new Set(availableIds);
      const variants = (this.product.variants || []).slice().sort((a, b) => {
        const aRank = availSet.has(a.id) ? 0 : 1;
        const bRank = availSet.has(b.id) ? 0 : 1;
        return aRank - bRank;
      });

      for (let n = 0; n < targetQty; n++) {
        let addedThisRound = false;
        for (const variant of variants) {
          if (!variant?.id) continue;
          const result = await this.postCartAddFormData({ id: variant.id, quantity: 1 });
          if (!result.ok) {
            lastApiMsg = result.apiMsg || lastApiMsg;
            continue;
          }
          addedQty += 1;
          lastData = result.data;
          addedThisRound = true;
          break;
        }
        if (!addedThisRound) break;
      }

      return { addedQty, lastData, lastApiMsg };
    }

    async requestEditorCartAdd(items) {
      const minimal = this.stripSellingPlansFromItems(this.stripPropertiesFromItems(items));
      const targetQty = minimal.reduce((sum, item) => sum + (parseInt(item.quantity, 10) || 0), 0) || 1;
      const availableIds = await this.fetchEditorAvailableVariantIds();
      const lines = this.buildEditorCartLines(minimal, availableIds, targetQty);

      let attempt = await this.addEditorLinesUnitByUnit(lines);
      if (attempt.addedQty > 0) {
        return {
          ok: true,
          data: attempt.lastData,
          addedQty: attempt.addedQty,
          strategy: 'editor-lines',
          partial: attempt.addedQty < targetQty
        };
      }

      attempt = await this.addEditorAnyAvailableVariants(targetQty);
      if (attempt.addedQty > 0) {
        return {
          ok: true,
          data: attempt.lastData,
          addedQty: attempt.addedQty,
          strategy: 'editor-scan',
          partial: attempt.addedQty < targetQty
        };
      }

      const jsonResult = await this.requestCartAddWithFallbacks(items, {});
      if (jsonResult.ok) {
        return { ...jsonResult, strategy: 'editor-json', partial: (jsonResult.addedQty || 0) < targetQty };
      }

      const existingCart = await this.fetchEditorCart();
      if (existingCart && existingCart.item_count > 0) {
        return {
          ok: true,
          data: existingCart,
          addedQty: existingCart.item_count,
          strategy: 'editor-existing-cart',
          partial: true
        };
      }

      return {
        ok: false,
        apiMsg: jsonResult.apiMsg || attempt.lastApiMsg,
        addedQty: 0,
        strategy: 'failed'
      };
    }

    stripSellingPlansFromItems(items) {
      return items.map(item => {
        const next = { ...item };
        delete next.selling_plan;
        return next;
      });
    }

    stripPropertiesFromItems(items) {
      return items.map(item => {
        const next = { ...item };
        delete next.properties;
        return next;
      });
    }

    async addCartItemsSequentially(items, sectionsPayload) {
      let addedQty = 0;
      let lastData = null;

      for (const item of items) {
        const result = await this.postCartAdd({
          items: [item],
          ...sectionsPayload
        });
        if (!result.ok) continue;
        addedQty += parseInt(item.quantity, 10) || 0;
        lastData = result.data;
      }

      return addedQty > 0 ? { ok: true, data: lastData, addedQty } : { ok: false, addedQty: 0 };
    }

    async requestCartAddWithFallbacks(items, sectionsPayload) {
      const attempts = [
        { items, label: 'primary' },
        { items: this.stripSellingPlansFromItems(items), label: 'one-time' },
        { items: this.stripPropertiesFromItems(items), label: 'no-properties' },
        { items: this.stripSellingPlansFromItems(this.stripPropertiesFromItems(items)), label: 'minimal' }
      ];

      const seen = new Set();
      let lastApiMsg = '';

      for (const attempt of attempts) {
        const key = JSON.stringify(attempt.items);
        if (seen.has(key)) continue;
        seen.add(key);

        const result = await this.postCartAdd({
          items: attempt.items,
          ...sectionsPayload
        });
        if (result.ok) {
          return {
            ok: true,
            data: result.data,
            addedQty: attempt.items.reduce((sum, item) => sum + (parseInt(item.quantity, 10) || 0), 0),
            strategy: attempt.label
          };
        }
        lastApiMsg = result.apiMsg || lastApiMsg;
      }

      if (this.isDesignMode()) {
        for (const sequentialItems of [
          this.stripSellingPlansFromItems(this.stripPropertiesFromItems(items)),
          items
        ]) {
          const sequential = await this.addCartItemsSequentially(sequentialItems, {});
          if (sequential.ok) {
            return { ...sequential, strategy: 'sequential' };
          }
        }
      }

      return {
        ok: false,
        apiMsg: lastApiMsg,
        addedQty: 0,
        strategy: 'failed'
      };
    }

    formDataToAddPayload(formData, sectionIds) {
      const id = formData.get('id');
      if (!id) throw new Error('Variant is required');

      const item = {
        id: Number(id),
        quantity: Number(formData.get('quantity') || 1)
      };

      const plan = formData.get('selling_plan');
      if (plan) item.selling_plan = String(plan);

      const properties = {};
      formData.forEach((value, key) => {
        const match = String(key).match(/^properties\[(.+)\]$/);
        if (match && value != null && String(value).trim() !== '') {
          properties[match[1]] = String(value);
        }
      });
      if (Object.keys(properties).length) item.properties = properties;

      return {
        items: [item],
        ...this.buildSectionsPayload(sectionIds)
      };
    }

    parseItemCountFromSections(sections, fallback) {
      if (!sections || typeof sections !== 'object') return fallback;

      for (const html of Object.values(sections)) {
        if (typeof html !== 'string') continue;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const candidates = [
          ...doc.querySelectorAll(
            '.custom-cart-heading [ref="cartItemCount"], [ref="cartItemCount"]'
          )
        ].filter(el => !el.closest('template'));
        for (const el of candidates) {
          const n = parseInt(el.textContent, 10);
          if (Number.isFinite(n)) return n;
        }
      }

      return fallback;
    }

    async resolveCartItemCount(addData, sections, fallback) {
      if (typeof addData?.item_count === 'number') return addData.item_count;
      const parsed = this.parseItemCountFromSections(sections, null);
      if (typeof parsed === 'number') return parsed;
      try {
        const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (res.ok) {
          const cart = await res.json();
          if (typeof cart.item_count === 'number') return cart.item_count;
        }
      } catch (_) {}
      return fallback;
    }

    async morphCartSections(sections) {
      if (!sections || typeof sections !== 'object') return;

      try {
        const { morphSection } = await import('@theme/section-renderer');
        const jobs = [];

        document.querySelectorAll('cart-items-component').forEach(el => {
          const sid = el.dataset.sectionId;
          if (!sid || !sections[sid]) return;
          jobs.push(
            morphSection(sid, sections[sid], {
              mode: el.hasAttribute('data-drawer') ? 'hydration' : 'full'
            })
          );
        });

        await Promise.all(jobs);
      } catch (err) {
        console.warn('[product-info-custom] cart morph failed:', err);
      }
    }

    dispatchPiCartUpdate(cart, sections, itemCountOverride, skipSectionRender) {
      const variantId = this.state.variant && this.state.variant.id;
      let itemCount;

      if (typeof itemCountOverride === 'number' && Number.isFinite(itemCountOverride)) {
        itemCount = itemCountOverride;
      } else if (cart && typeof cart.item_count === 'number') {
        itemCount = cart.item_count;
      } else if (sections) {
        itemCount = this.parseItemCountFromSections(sections, this.getCurrentCartCount());
      } else {
        itemCount = this.getCurrentCartCount();
      }

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: this.sectionId,
            data: {
              source: 'product-info-custom',
              productId: String(this.productId),
              variantId: variantId ? String(variantId) : undefined,
              itemCount,
              sections,
              skipSectionRender: !!skipSectionRender
            }
          }
        })
      );
      if (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }

    /**
     * Discount code for the selected pack. The card's own settings win; the
     * qty map is the PDP-V1 fallback so Duo/Trio behave the same on both pages.
     */
    getBundleDiscountCode() {
      const card = this.state.bundleEl;
      const qty = this.state.bundleQty || 1;
      const subscribed = !!(
        this.state.subscribed && this.subscribeBlock?.dataset?.state === 'enabled'
      );

      const subCode = String(card?.dataset.piSubscriptionDiscountCode || '').trim();
      const oneTime = String(card?.dataset.piCartDiscountCode || '').trim();

      if (subscribed && subCode) return subCode;
      if (!subscribed && oneTime) return oneTime;
      if (subscribed && oneTime) return oneTime;

      if (qty === 2) return subscribed ? 'DUO-BUNDLE-SUB' : 'DUO-BUNDLE';
      if (qty === 3) return subscribed ? 'TRIO-BUNDLE-SUB' : 'TRIO-BUNDLE';
      return '';
    }

    /**
     * Line item properties that let the cart drawer and cart page treat several
     * lines as one pack. Names must stay in sync with PDP-V1.
     */
    buildPackProperties() {
      const qty = this.state.bundleQty || 1;
      if (qty < 2) return {};

      const card = this.state.bundleEl;
      const unitPrice = this.getBundleBaseUnitCents(this.state.variant);
      const payCents = this.packTotalCents(card, unitPrice, qty, this.state.bundleDiscount);
      const buildName =
        String(card?.dataset.piBuildName || '').trim().toLowerCase() || String(qty);
      const code = this.getBundleDiscountCode();

      const packId = `${qty}-${Date.now().toString(36)}-${Math.random()
        .toString(36)
        .slice(2, 8)}`;

      const props = {
        _piv1_bundle: buildName,
        _piv1_qty: String(qty),
        _piv1_price_cents: String(payCents),
        _piv1_pack: packId
      };
      if (code) props._piv1_discount = code;
      return props;
    }

    /**
     * Reads the live cart and works out which discount code(s) the whole cart
     * needs. Duo + Trio together collapse to the merged order-level code because
     * two product discounts cannot stack on the same line.
     */
    async resolveCartDiscountState(tierCode) {
      const codes = new Set();
      if (tierCode) codes.add(String(tierCode).trim().toUpperCase());

      let lockQty = this.state.bundleQty || 1;
      const productId = this.state.variant?.product_id || this.product?.id || '';

      try {
        const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (res.ok) {
          const cart = await res.json();
          const seenPacks = new Set();

          for (const item of cart.items || []) {
            const props = item.properties || {};
            if (
              String(props._trio_gift || '') === '1' ||
              String(props._free_gift || '').toLowerCase() === 'yes'
            ) {
              continue;
            }

            const packQty = parseInt(props._piv1_qty || props['Bundle quantity'] || '0', 10);
            if (!(packQty >= 2)) continue;

            const packId = String(props._piv1_pack || '').trim();
            const key = packId || `${item.product_id}:q${packQty}`;
            if (seenPacks.has(key)) continue;
            seenPacks.add(key);

            const isSub = !!item.selling_plan_allocation;
            let disc = String(props._piv1_discount || '').trim().toUpperCase();
            if (packQty === 2) disc = isSub ? 'DUO-BUNDLE-SUB' : 'DUO-BUNDLE';
            else if (packQty === 3) disc = isSub ? 'TRIO-BUNDLE-SUB' : 'TRIO-BUNDLE';
            if (disc) codes.add(disc);
            if (packQty > lockQty) lockQty = packQty;
          }
        }
      } catch (e) {
        console.warn('[product-info-custom] cart read for discount sync failed:', e);
      }

      const codeList = [...codes].filter(Boolean);
      const hasDuo = codeList.some(c => c === 'DUO-BUNDLE' || c === 'DUO-BUNDLE-SUB');
      const hasTrio = codeList.some(c => c === 'TRIO-BUNDLE' || c === 'TRIO-BUNDLE-SUB');
      const merged =
        hasDuo && hasTrio
          ? codeList.some(c => c.endsWith('-SUB'))
            ? 'DUO-TRIO-SUB'
            : 'DUO-TRIO'
          : '';

      return {
        discountValue: merged || codeList.join(','),
        lockValue: productId && lockQty >= 2 ? `${productId}:${lockQty}` : ''
      };
    }

    async syncCartAfterAdd(tierCode, sectionIds) {
      if (!tierCode) return null;

      const cartUpdateUrl =
        (typeof window !== 'undefined' &&
          window.Theme &&
          window.Theme.routes &&
          window.Theme.routes.cart_update_url) ||
        '/cart/update.js';
      const updHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };
      const updOpts = { method: 'POST', headers: updHeaders };
      const sectionsPayload = this.buildSectionsPayload(sectionIds || this.getCartSectionIds());

      try {
        const { discountValue, lockValue } = await this.resolveCartDiscountState(tierCode);

        await fetch(cartUpdateUrl, {
          ...updOpts,
          body: JSON.stringify({
            discount: '',
            ...(lockValue ? { attributes: { _cp_locked_bundle: lockValue } } : {})
          })
        });
        const updRes = await fetch(cartUpdateUrl, {
          ...updOpts,
          body: JSON.stringify({
            discount: discountValue || tierCode,
            ...(lockValue ? { attributes: { _cp_locked_bundle: lockValue } } : {}),
            ...sectionsPayload
          })
        });

        if (!updRes.ok) return null;

        const cart = await updRes.json();
        if (cart?.sections) {
          await this.morphCartSections(cart.sections);
        }
        this.dispatchPiCartUpdate(cart, cart?.sections, undefined, true);
        return cart;
      } catch (e) {
        console.warn('[product-info-custom] bundle discount code apply failed:', e);
        return null;
      }
    }

    /** Theme editor only — live storefront uses submitATC() unchanged. */
    async submitATCInEditor() {
      const EDITOR_ADD_TIMEOUT = 5000;
      const EDITOR_CART_TIMEOUT = 4000;

      try {
        this.syncSellingPlanInput();

        const useMix = this.isBundleMixEnabled();
        const sectionIds = this.getCartSectionIds();
        let cartItems = [];
        let addedQty = this.state.bundleQty || 1;

        if (useMix) {
          this.repairBundleMixIfNeeded();
          const items = this.getBundleMixItems();
          const summary = this.getBundleMixSummaryText();
          cartItems = items.map(item => ({
            id: item.id,
            quantity: item.quantity,
            properties: {
              'Bundle quantity': String(this.state.bundleQty),
              'Bundle mix': 'Yes',
              ...(summary ? { 'Bundle mix summary': summary } : {})
            }
          }));
          addedQty = items.reduce((sum, item) => sum + item.quantity, 0);
        } else {
          const formData = new FormData(this.form);
          if (this.planInput && this.planInput.disabled) formData.delete('selling_plan');
          addedQty = Number(formData.get('quantity') || 1);
          cartItems = [{ id: Number(formData.get('id')), quantity: addedQty }];
        }

        const [addAttempt, editorCart] = await Promise.all([
          this.postCartAddEditorFast(cartItems, EDITOR_ADD_TIMEOUT),
          this.fetchEditorCartFast(EDITOR_CART_TIMEOUT)
        ]);

        let addResult = addAttempt;
        if (!addResult.ok && editorCart?.item_count > 0) {
          addResult = { ok: true, data: editorCart, addedQty: editorCart.item_count };
        }

        if (!addResult.ok) {
          this.setAtcLoading(false);
          this.refreshAtcAvailability();
          alert(
            'Theme editor could not add to cart. Try “View your store” to test — live add to cart works.'
          );
          return;
        }

        if (typeof addResult.addedQty === 'number' && addResult.addedQty > 0) {
          addedQty = addResult.addedQty;
        }

        this.setAtcLoading(false);

        const labelEl = $('[data-pi-atc-label]', this.atcBtn);
        if (labelEl) labelEl.textContent = this.atcBtn.dataset.textAdded || 'Added!';
        this.atcBtn.classList.add('pi-atc-btn--added');
        this.atcBtn.disabled = false;

        setTimeout(() => {
          this.atcBtn.classList.remove('pi-atc-btn--added');
          this.refreshAtcAvailability();
        }, 1800);

        this.editorRefreshCartDrawerAfterAdd(addResult.data, sectionIds, addedQty).catch(err => {
          console.warn('[product-info-custom] editor cart refresh failed:', err);
        });
      } catch (err) {
        console.warn('[product-info-custom] editor ATC error:', err);
        this.setAtcLoading(false);
        this.refreshAtcAvailability();
        alert(err.message || 'Could not add to cart in theme editor.');
      }
    }

    async editorRefreshCartDrawerAfterAdd(addData, sectionIds, addedQty) {
      let cart = addData || {};
      const liveCart = await this.fetchEditorCartFast(4000);
      if (liveCart) cart = liveCart;

      let sections = cart.sections;
      if (!sections || !Object.keys(sections).length) {
        sections = await this.fetchCartSectionsForEditor(sectionIds, window.location.pathname);
      }

      const itemCount = await this.resolveCartItemCount(
        cart,
        sections,
        this.getCurrentCartCount() + addedQty
      );

      this.openCartDrawer();
      this.dispatchPiCartUpdate(cart, sections, itemCount, true);

      if (sections) {
        await this.morphCartSections(sections);
      }
    }

    async submitATC() {
      if (!this.atcBtn || this.atcBtn.disabled || this.atcBtn.classList.contains('pi-atc-btn--loading')) return;

      this.setAtcLoading(true);

      if (this.isDesignMode()) {
        await this.submitATCInEditor();
        return;
      }

      try {
        await this.refreshProductAvailability();
        this.syncSellingPlanInput();
        const useMix = this.isBundleMixEnabled();
        const sectionIds = this.getCartSectionIds();
        const sectionsPayload = this.buildSectionsPayload(sectionIds);

        let addResult;
        let addedQty = this.state.bundleQty || 1;

        if (useMix) {
          this.repairBundleMixIfNeeded();

          const items = this.getBundleMixItems();
          const total = items.reduce((sum, item) => sum + item.quantity, 0);
          addedQty = total;
          if (total !== this.state.bundleQty) {
            throw new Error(
              `Not enough in-stock scents to fill this ${this.state.bundleQty}-item bundle. ` +
              'Restock variants in Admin → Products or choose a smaller bundle.'
            );
          }

          const inventoryErr = this.validateBundleMixInventory();
          if (inventoryErr) throw new Error(inventoryErr);

          const summary = this.getBundleMixSummaryText();
          const packProps = this.buildPackProperties();
          const cartItems = items.map(item => ({
            id: item.id,
            quantity: item.quantity,
            ...(this.state.subscribed && this.getActivePlanIdForVariant(this.findVariantById(item.id))
              ? { selling_plan: String(this.getActivePlanIdForVariant(this.findVariantById(item.id))) }
              : {}),
            properties: {
              'Bundle quantity': String(this.state.bundleQty),
              'Bundle mix': 'Yes',
              ...(summary ? { 'Bundle mix summary': summary } : {}),
              ...packProps
            }
          }));

          if (
            this.state.subscribed &&
            this.subscribeBlock?.dataset?.state === 'enabled'
          ) {
            const missingPlan = cartItems.some(line => !line.selling_plan);
            if (missingPlan) {
              throw new Error('One or more selected scents are not available for subscription.');
            }
          }

          addResult = await this.requestCartAddWithFallbacks(cartItems, sectionsPayload);
        } else {
          const formData = new FormData(this.form);
          if (this.planInput && this.planInput.disabled) formData.delete('selling_plan');
          addedQty = Number(formData.get('quantity') || 1);

          const inventoryErr = this.getVariantInventoryError(this.state.variant, addedQty);
          if (inventoryErr) throw new Error(inventoryErr);

          const payload = this.formDataToAddPayload(formData, sectionIds);
          const packProps = this.buildPackProperties();
          if (Object.keys(packProps).length) {
            payload.items = payload.items.map(item => ({
              ...item,
              properties: { ...(item.properties || {}), ...packProps }
            }));
          }
          addResult = await this.requestCartAddWithFallbacks(payload.items, sectionsPayload);
        }

        if (!addResult.ok) {
          const apiMsg = addResult.apiMsg || '';
          if (apiMsg) {
            console.error('[product-info-custom] cart/add rejected:', addResult.data || apiMsg);
          }
          throw new Error(this.formatCartAddError(apiMsg));
        }

        let addData = addResult.data || {};
        if (typeof addResult.addedQty === 'number' && addResult.addedQty > 0) {
          addedQty = addResult.addedQty;
        }

        const tierCode = this.getBundleDiscountCode();

        const itemCountFallback = this.getCurrentCartCount() + addedQty;
        const sections = addData.sections;
        const itemCount = await this.resolveCartItemCount(addData, sections, itemCountFallback);

        const redirected = this.handleAfterAdd();
        if (redirected) return;

        this.dispatchPiCartUpdate(addData, sections, itemCount, true);

        if (tierCode) {
          this.syncCartAfterAdd(tierCode, sectionIds).catch(err => {
            console.warn('[product-info-custom] cart sync after add:', err);
          });
        }

        this.setAtcLoading(false);

        this.morphCartSections(sections).catch(morphErr => {
          console.warn('[product-info-custom] cart morph failed:', morphErr);
        });

        const labelEl = $('[data-pi-atc-label]', this.atcBtn);
        if (labelEl) labelEl.textContent = this.atcBtn.dataset.textAdded || 'Added!';
        this.atcBtn.classList.add('pi-atc-btn--added');
        this.atcBtn.disabled = false;

        setTimeout(() => {
          this.atcBtn.classList.remove('pi-atc-btn--added');
          this.refreshAtcAvailability();
        }, 1800);

      } catch (err) {
        console.error('[product-info-custom] ATC error:', err);
        this.setAtcLoading(false);
        this.refreshAtcAvailability();
        document.dispatchEvent(new CustomEvent('cart:error', {
          bubbles: true,
          detail: { sourceId: this.sectionId, data: { message: err.message } }
        }));
        alert(err.message || 'Could not add to cart. Please try again.');
      }
    }

    openCartDrawer() {
      if (window.__ssAtcNavigateAway) return;
      const action = this.afterAddAction();
      if (action === 'cart' || action === 'checkout') return;

      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }

      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger && typeof trigger.click === 'function') {
        trigger.click();
      }
    }

    afterAddAction() {
      const fromBtn = this.atcBtn?.dataset?.afterAdd;
      const fromEl = this.el?.dataset?.afterAdd;
      return String(fromBtn || fromEl || 'drawer').trim().toLowerCase();
    }

    closeCartDrawerQuietly() {
      const drawer = document.querySelector('cart-drawer-component');
      try {
        if (drawer && typeof drawer.close === 'function') drawer.close();
      } catch (_) {
        /* ignore */
      }
      drawer?.querySelectorAll?.('dialog[open]').forEach(dialog => {
        try {
          dialog.close();
        } catch (_) {
          /* ignore */
        }
      });
    }

    handleAfterAdd() {
      if (this.isDesignMode()) {
        this.openCartDrawer();
        return false;
      }
      const action = this.afterAddAction();
      if (action === 'cart' || action === 'checkout') {
        window.__ssAtcNavigateAway = true;
        this.closeCartDrawerQuietly();
        const url =
          action === 'checkout'
            ? this.el?.dataset?.checkoutUrl || '/checkout'
            : this.el?.dataset?.cartUrl || '/cart';
        window.location.assign(url);
        return true;
      }
      this.openCartDrawer();
      return false;
    }

    /* ─────────────────────────────────────────────────────────
       TESTIMONIAL CAROUSEL
       • Dots are rendered OUTSIDE slides → always selectable
       • data-auto-slide / data-slide-interval from Liquid schema
       • Timer resets when user clicks a dot manually
    ───────────────────────────────────────────────────────── */
    initTestimonialCarousel() {
      $$('[data-pi-testi]', this.el).forEach(wrap => {
        const slides    = $$('.pi-testi-slide', wrap);
        const metas     = $$('.pi-testi-meta', wrap);   // one per slide, in pi-testi-meta-items
        const dots      = $$('.pi-testi-dot', wrap);
        const autoSlide = wrap.dataset.autoSlide !== 'false';
        const interval  = (parseInt(wrap.dataset.slideInterval, 10) || 5) * 1000;

        if (slides.length === 0) return;

        let current = 0;
        let timer   = null;

        const goTo = (idx) => {
          slides[current]?.classList.remove('is-active');
          metas[current]?.classList.remove('is-active');
          dots[current]?.classList.remove('is-active');
          current = ((idx % slides.length) + slides.length) % slides.length;
          slides[current]?.classList.add('is-active');
          metas[current]?.classList.add('is-active');
          dots[current]?.classList.add('is-active');
        };

        dots.forEach((d, i) => {
          d.addEventListener('click', () => {
            goTo(i);
            if (autoSlide && slides.length > 1) {
              clearInterval(timer);
              timer = setInterval(() => goTo(current + 1), interval);
            }
          });
        });

        goTo(0);

        if (slides.length > 1 && autoSlide) {
          timer = setInterval(() => goTo(current + 1), interval);
        }
      });
    }

    /* ─────────────────────────────────────────────────────────
       ACCORDION
    ───────────────────────────────────────────────────────── */
    initAccordion() {
      $$('.pi-accordion-trigger', this.el).forEach(trigger => {
        trigger.addEventListener('click', () => {
          const item    = trigger.closest('.pi-accordion-item');
          const content = item?.querySelector('.pi-accordion-content');
          const isOpen  = item?.classList.contains('is-open');

          $$('.pi-accordion-item', this.el).forEach(i => {
            i.classList.remove('is-open');
            i.querySelector('.pi-accordion-content')?.classList.remove('is-open');
          });

          if (!isOpen) {
            item?.classList.add('is-open');
            content?.classList.add('is-open');
          }

          trigger.setAttribute('aria-expanded', String(!isOpen));
        });
      });
    }

    /* ─────────────────────────────────────────────────────────
       MEDIA REVIEWS CAROUSEL
       • data-pi-videos wraps each carousel (first card only renders the container)
       • Supports image cards (lightbox) and video cards (modal)
       • Marquee mode: duplicate DOM, CSS animation runs the loop
       • Auto-slide: JS interval advances cards in arrow mode
       • Mobile: CSS shows 2.5 cards; JS uses getVisible()=2 for offset maths
    ───────────────────────────────────────────────────────── */
    initVideoCarousel() {
      const modal      = $('.pi-video-modal', this.el);
      const modalInner = $('.pi-video-modal__inner', this.el);

      const closeModal = () => {
        modal?.classList.remove('is-open');
        if (modalInner) {
          modalInner.innerHTML  = '';
          modalInner.className  = 'pi-video-modal__inner';
        }
        document.body.style.overflow = '';
      };

      if (modal) {
        modal.addEventListener('click', e => { if (e.target === modal) closeModal(); });
      }
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && modal?.classList.contains('is-open')) closeModal();
      });

      $$('[data-pi-videos]', this.el).forEach(wrap => {
        const track         = $('.pi-videos__track', wrap);
        const prevBtn       = $('.pi-videos__arrow--prev', wrap);
        const nextBtn       = $('.pi-videos__arrow--next', wrap);
        const marqueeMode    = wrap.dataset.marqueeMode === 'true';
        const autoSlide      = wrap.dataset.autoSlide === 'true';
        const slideInterval  = (parseInt(wrap.dataset.slideInterval, 10) || 3) * 1000;
        const mobileVis      = parseFloat(wrap.dataset.mobileCards || '2.5');

        if (!track) return;

        /* ── Marquee: duplicate content, CSS animation drives it ── */
        if (marqueeMode) {
          track.innerHTML = track.innerHTML + track.innerHTML;
          return;
        }

        const getVisible = () => {
          if (window.innerWidth < 768) return Math.floor(mobileVis);
          return 4;
        };

        const getGap = () => {
          const styles = window.getComputedStyle(track);
          return parseFloat(styles.columnGap || styles.gap || '8') || 8;
        };

        const cardStepWidth = () => {
          const firstOrig = $('.pi-video-card:not([data-pi-vclone])', track);
          if (!firstOrig) return 0;
          return firstOrig.getBoundingClientRect().width + getGap();
        };

        let clones = [];
        let translatePx = 0;
        let originalWidth = 0;

        const removeClones = () => {
          clones.forEach(c => c.remove());
          clones = [];
        };

        const appendClones = () => {
          removeClones();
          const originals = $$('.pi-video-card:not([data-pi-vclone])', track);
          originals.forEach(node => {
            const cl = node.cloneNode(true);
            cl.dataset.piVclone = '1';
            track.appendChild(cl);
            clones.push(cl);
          });
        };

        const rebuildInfinite = () => {
          const originals = $$('.pi-video-card:not([data-pi-vclone])', track);
          const n = originals.length;
          removeClones();
          translatePx = 0;
          track.style.transition = 'none';
          track.style.transform = 'translateX(0)';
          void track.offsetHeight;
          track.style.transition = '';
          originalWidth = 0;
          const vis = getVisible();
          if (n <= vis || n === 0) return;
          appendClones();
          originalWidth = track.scrollWidth / 2;
        };

        const slideInstant = () => {
          track.style.transition = 'none';
          track.style.transform = `translateX(-${translatePx}px)`;
          void track.offsetHeight;
          track.style.transition = '';
        };

        const slideAnimated = () => {
          track.style.transform = `translateX(-${translatePx}px)`;
        };

        const normalizeAfterSlide = () => {
          if (!originalWidth) return;
          while (translatePx >= originalWidth - 0.5) translatePx -= originalWidth;
          slideInstant();
        };

        track.addEventListener('transitionend', e => {
          if (e.target !== track || e.propertyName !== 'transform') return;
          normalizeAfterSlide();
        });

        const stepNext = () => {
          const n = $$('.pi-video-card:not([data-pi-vclone])', track).length;
          const vis = getVisible();
          if (n <= vis || !originalWidth) return;
          const step = cardStepWidth();
          if (!step) return;
          translatePx += step;
          slideAnimated();
        };

        const stepPrev = () => {
          const n = $$('.pi-video-card:not([data-pi-vclone])', track).length;
          const vis = getVisible();
          if (n <= vis || !originalWidth) return;
          const step = cardStepWidth();
          if (!step) return;
          translatePx -= step;
          if (translatePx < -0.5) translatePx += originalWidth;
          slideAnimated();
        };

        rebuildInfinite();

        prevBtn?.addEventListener('click', () => stepPrev());
        nextBtn?.addEventListener('click', () => stepNext());

        /* ── Click: video modal or image lightbox (delegation — includes clones) ── */
        const openCard = (card) => {
          const mediaType = card.dataset.mediaType || 'video';

          if (mediaType === 'image') {
            const imgUrl = card.dataset.imageUrl;
            if (!imgUrl || !modal || !modalInner) return;
            modalInner.className = 'pi-video-modal__inner pi-video-modal__inner--image';
            modalInner.innerHTML = `<img src="${imgUrl}" alt="">
              <button class="pi-video-modal__close" aria-label="Close">✕</button>`;
            modalInner.querySelector('.pi-video-modal__close')
              ?.addEventListener('click', closeModal);
            modal.classList.add('is-open');
            document.body.style.overflow = 'hidden';
            return;
          }

          const url = card.dataset.videoUrl;
          if (!url || !modal || !modalInner) return;

          let embedHtml = '';
          if (url.includes('youtube.com') || url.includes('youtu.be')) {
            const id = url.match(/(?:v=|youtu\.be\/|shorts\/)([\w-]+)/)?.[1];
            if (id) embedHtml = `<iframe src="https://www.youtube.com/embed/${id}?autoplay=1&rel=0" frameborder="0" allowfullscreen allow="autoplay; fullscreen"></iframe>`;
          } else if (url.includes('vimeo.com')) {
            const id = url.match(/vimeo\.com\/(\d+)/)?.[1];
            if (id) embedHtml = `<iframe src="https://player.vimeo.com/video/${id}?autoplay=1" frameborder="0" allowfullscreen allow="autoplay; fullscreen"></iframe>`;
          } else if (url) {
            embedHtml = `<video src="${url}" controls autoplay playsinline style="border-radius:8px;width:100%;height:100%;"></video>`;
          }

          if (embedHtml) {
            modalInner.className = 'pi-video-modal__inner';
            modalInner.innerHTML = embedHtml +
              `<button class="pi-video-modal__close" aria-label="Close">✕</button>`;
            modalInner.querySelector('.pi-video-modal__close')
              ?.addEventListener('click', closeModal);
            modal.classList.add('is-open');
            document.body.style.overflow = 'hidden';
          }
        };

        track.addEventListener('click', e => {
          const card = e.target.closest('.pi-video-card');
          if (!card || !track.contains(card)) return;
          const mediaType = card.dataset.mediaType || 'video';
          if (mediaType === 'image' && !card.dataset.imageUrl) return;
          openCard(card);
        });

        /* ── Touch swipe ── */
        let startX = 0;
        track.addEventListener('touchstart', e => {
          startX = e.touches[0].clientX;
        }, { passive: true });
        track.addEventListener('touchend', e => {
          const diff = startX - e.changedTouches[0].clientX;
          if (diff > 40) stepNext();
          if (diff < -40) stepPrev();
        });

        /* ── Auto-slide (seamless loop; no snap-back) ── */
        let autoTimer = null;
        if (autoSlide) {
          autoTimer = window.setInterval(() => {
            stepNext();
          }, slideInterval);
          wrap.addEventListener('mouseenter', () => {
            if (autoTimer) window.clearInterval(autoTimer);
          });
          wrap.addEventListener('mouseleave', () => {
            if (autoTimer) window.clearInterval(autoTimer);
            autoTimer = window.setInterval(() => stepNext(), slideInterval);
          });
        }

        let resizeT = null;
        window.addEventListener('resize', () => {
          window.clearTimeout(resizeT);
          resizeT = window.setTimeout(() => {
            rebuildInfinite();
            slideAnimated();
          }, 120);
        });
      });
    }

    /* ─────────────────────────────────────────────────────────
       INGREDIENTS POPUP
    ───────────────────────────────────────────────────────── */
    initIngredientsPopup() {
      $$('[data-pi-ing]', this.el).forEach(btn => {
        const id    = btn.dataset.piIng;
        const modal = document.getElementById(`pi-ing-${id}`);
        if (!modal) return;

        const open = () => {
          if (modal.classList.contains('is-open')) return;
          this.syncIngredientsPopupImages();
          modal.classList.add('is-open');
          bumpPiIngredientsModal(1);
        };
        const close = () => {
          if (!modal.classList.contains('is-open')) return;
          modal.classList.remove('is-open');
          bumpPiIngredientsModal(-1);
        };

        btn.addEventListener('click', open);
        $$('[data-pi-ing-close]', modal).forEach(c => c.addEventListener('click', close));
        document.addEventListener('keydown', e => {
          if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
        });
      });
    }
  }

  /* ─── Boot all sections ─── */
  function boot() {
    document.querySelectorAll('.pi-section').forEach(el => {
      if (el._piCustom) return;
      try {
        el._piCustom = new ProductInfoCustom(el);
      } catch (err) {
        console.error('[product-info-custom] section init failed:', err);
      }
    });
    initPagePiScroll();
    refreshDeliveryDateSpans(document.documentElement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /**
   * Theme editor: preview hot-reloads Product info and mutates layout (gallery / sticky column). Reading
   * scrollY inside `shopify:section:load` is too late—the browser may already have jumped. Capture Y
   * on `section:unload` (capture phase) and enforce it briefly after load + on resize bursts.
   */
  const PI_EDITOR_SCROLL_LOCK_MS = 1400;
  let piEditorPendingScrollY = null;
  let piEditorScrollRafId = 0;
  let piScrollEnforceTimerId = 0;
  let piEditorScrollLockUntil = 0;
  let piEditorResizeDetach = null;

  function piIsDesignPreview() {
    return (
      typeof Shopify !== 'undefined' &&
      Shopify.designMode &&
      document.documentElement.classList.contains('shopify-design-mode')
    );
  }

  function piUnloadRootHasProductInfo(ev) {
    const t = ev.target;
    if (!(t instanceof HTMLElement)) return false;
    const sec = t.classList?.contains('shopify-section') ? t : t.closest?.('.shopify-section');
    return !!(sec instanceof HTMLElement && sec.querySelector('.pi-section'));
  }

  function piStopScrollEnforcement() {
    if (piEditorScrollRafId) {
      cancelAnimationFrame(piEditorScrollRafId);
      piEditorScrollRafId = 0;
    }
    if (piScrollEnforceTimerId) {
      clearTimeout(piScrollEnforceTimerId);
      piScrollEnforceTimerId = 0;
    }
    piEditorScrollLockUntil = 0;
    if (typeof piEditorResizeDetach === 'function') {
      piEditorResizeDetach();
      piEditorResizeDetach = null;
    }
  }

  function piStartScrollEnforcement(targetY) {
    if (!Number.isFinite(targetY)) return;
    piStopScrollEnforcement();
    piEditorScrollLockUntil = performance.now() + PI_EDITOR_SCROLL_LOCK_MS;

    const snap = () => {
      window.scrollTo(0, targetY);
    };

    const onResize = () => snap();
    window.addEventListener('resize', onResize, { passive: true });
    piEditorResizeDetach = () => window.removeEventListener('resize', onResize);

    const frame = () => {
      if (performance.now() > piEditorScrollLockUntil) {
        piStopScrollEnforcement();
        return;
      }
      if (Math.abs(window.scrollY - targetY) > 2) snap();
      piEditorScrollRafId = requestAnimationFrame(frame);
    };

    snap();
    queueMicrotask(snap);
    requestAnimationFrame(snap);
    requestAnimationFrame(() => requestAnimationFrame(snap));
    setTimeout(snap, 0);
    setTimeout(snap, 48);
    setTimeout(snap, 160);
    piEditorScrollRafId = requestAnimationFrame(frame);
    piScrollEnforceTimerId = window.setTimeout(() => {
      piScrollEnforceTimerId = 0;
      piStopScrollEnforcement();
    }, PI_EDITOR_SCROLL_LOCK_MS + 50);
  }

  document.addEventListener(
    'shopify:section:unload',
    ev => {
      if (!piIsDesignPreview()) return;
      if (!piUnloadRootHasProductInfo(ev)) return;
      piEditorPendingScrollY = window.scrollY;
    },
    true
  );

  document.addEventListener('shopify:section:load', e => {
    const root = e.target instanceof HTMLElement ? e.target : null;
    if (!root?.querySelector) return;

    const pi = root.querySelector('.pi-section');
    let restoreY = null;
    if (piIsDesignPreview() && pi) {
      restoreY = piEditorPendingScrollY;
      piEditorPendingScrollY = null;
      if (restoreY == null || !Number.isFinite(restoreY)) {
        restoreY = window.scrollY;
      }
    }

    if (pi && !pi._piCustom) {
      try {
        pi._piCustom = new ProductInfoCustom(pi);
      } catch (err) {
        console.error('[product-info-custom] section reload init failed:', err);
      }
    }
    initPagePiScroll(document.querySelector('.pi-section'));
    refreshDeliveryDateSpans(root);

    if (restoreY !== null && Number.isFinite(restoreY)) piStartScrollEnforcement(restoreY);
  });
})();
